import {Decoder} from 'json-bouncer'
import * as OrderFilter from '../Components/OrderFiltering/Model/OrderFilter'
import * as FilteredAndPaginated from '../Data/FilteredAndPaginated'
import {OrderWithOwners, orderWithOwnersDecoder} from './OrderWithOwners'

export type M =
    FilteredAndPaginated.M<OrderWithOwners, OrderFilter.OrderFilter>

export function decoder(): Decoder<M> {
    return FilteredAndPaginated.decoder(
        OrderFilter.decoder(),
        orderWithOwnersDecoder(),
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/FilteredAndPaginatedOrdersWithOwners.ts